import { Api } from '@common/services/api';

export const deleteMessage = async (organisationId: string, conversationId: string, messageId: string) => {
  return Api.delete<{ success: boolean }>(
    `/v3/organisations/${organisationId}/conversations/${conversationId}/messages/${messageId}`,
  );
};
